import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'analytics',
        loadComponent: () => import('./features/analytics-pro/analytics-pro.component').then(m => m.AnalyticsProComponent),
      },
      {
        path: 'pair/:pair',
        loadComponent: () => import('./features/pair-detail/pair-detail.component').then(m => m.PairDetailComponent),
      },
      {
        path: 'trades',
        loadComponent: () => import('./features/trades/trades.component').then(m => m.TradesComponent),
      },
      {
        path: 'trades/:id/qc',
        loadComponent: () => import('./features/trades/trade-qc.component').then(m => m.TradeQcComponent),
      },
      {
        path: 'config',
        loadComponent: () => import('./features/config/config.component').then(m => m.ConfigComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'swarm',
        loadComponent: () => import('./features/swarm/swarm.component').then(m => m.SwarmComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'signals',
        loadComponent: () => import('./features/signals/signals.component').then(m => m.SignalsComponent),
      },
      {
        path: 'trend-portfolio',
        loadComponent: () => import('./features/trend-portfolio/trend-portfolio.component').then(m => m.TrendPortfolioComponent),
      },
      {
        path: 'phantoms',
        loadComponent: () => import('./features/phantom-analysis/phantom-analysis.component').then(m => m.PhantomAnalysisComponent),
      },
      {
        path: 'strategy',
        loadComponent: () => import('./features/strategy/strategy.component').then(m => m.StrategyComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'backtest',
        loadComponent: () => import('./features/backtest/backtest.component').then(m => m.BacktestComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'transactions',
        loadComponent: () => import('./features/account/account-transactions/account-transactions.component').then(m => m.AccountTransactionsComponent),
      },
      {
        path: 'health',
        loadComponent: () => import('./features/health/health.component').then(m => m.HealthComponent),
      },
      {
        path: 'notifications',
        loadComponent: () => import('./features/notifications/notifications.component').then(m => m.NotificationsComponent),
      },
      {
        path: 'audit',
        loadComponent: () => import('./features/audit/audit.component').then(m => m.AuditComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'events',
        loadComponent: () => import('./features/event-feed/event-feed.component').then(m => m.EventFeedComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'replay',
        loadComponent: () => import('./features/backtest-replay/backtest-replay.component').then(m => m.BacktestReplayComponent),
        canActivate: [adminGuard],
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
